module.exports = __webpack_public_path__ + "static/img/bg-fr.ba5f2b4e.png";